export default {
  state: {
    videos: [],
    categories: []
  },

  mutations: {
    SET_VIDEOS: (state, { videos }) => {
      state.videos = videos
    },
    SET_CATEGORIES: (state, { categories }) => {
      state.categories = categories
    }
  },

  getters: {
    getVideos (state) {
      return state.videos
    },
    getCategories (state) {
      return state.categories
    }
  },

  actions: {
    setVideos ({ commit }, { videos }) {
      commit('SET_VIDEOS', { videos })
    },
    setCategories ({ commit }, { categories }) {
      commit('SET_CATEGORIES', { categories })
    }
  }
}

